exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3iIVVHlmwdTIGd8lsDxsgc{display:-webkit-box;-webkit-line-clamp:4;overflow:hidden;text-overflow:ellipsis}._2KjqnJzeOz9huOX9Wv-Ffk{width:530px!important}", ""]);

// exports
exports.locals = {
	"overflowHidden": "_3iIVVHlmwdTIGd8lsDxsgc",
	"checkInfoModal": "_2KjqnJzeOz9huOX9Wv-Ffk"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./apps/pages/main/workbench/Factor/index.css
// module id = 1604
// module chunks = 1